const getters = {
  leftSections: state => state.sectionsOrders.left,
  rightSections: state => state.sectionsOrders.right,
  blog: (state) => state.blog,
  faqs: (state) => state.faqs,
  changelog: (state) => state.changelog,
  recentPages: (state) => state.recentPages,
  startedGuideStep: (state) => state.startedGuideStep,
  openCustom: (state) => state.openCustom,
  banner: (state) => state.banner,
  loading: (state) => state.loading,
  firstCallGetApi: (state) => state.firstCallGetApi,
};

export default getters;
